import { quotePlan, validSelection, type CreditPlan } from "../../../../../packages/domain/src/billing.ts";
export async function availableBillingOffers(signal: AbortSignal): Promise<CreditPlan[]> {
  const response = await fetch("/api/v1/billing/offers", { credentials: "same-origin", signal });
  if (!response.ok) return [];
  const body = await response.json() as { offers?: unknown };
  if (!Array.isArray(body.offers)) return [];
  return body.offers.filter((value: unknown): value is CreditPlan => {
    if (!validSelection(value)) return false;
    const offer = value as CreditPlan & { totalCents?: unknown; currency?: unknown };
    return offer.currency === "USD" && offer.totalCents === quotePlan(offer.tier, offer.interval, offer.artists).totalCents;
  });
}
export async function createBillingCheckout(selection: CreditPlan, key: string, signal: AbortSignal, upgrade = false): Promise<string> {
  const response = await fetch("/api/v1/billing/checkout", { method: "POST", credentials: "same-origin", signal,
    headers: { "Content-Type": "application/json", "Idempotency-Key": key }, body: JSON.stringify({ ...selection, ...(upgrade ? { upgrade: true } : {}) }) });
  const body = await response.json() as { url?: unknown; error?: { message?: string } };
  if (!response.ok) throw new Error(body.error?.message ?? "Checkout could not be opened. Please try again.");
  if (typeof body.url !== "string") throw new Error("Checkout could not be opened. Please try again.");
  const url = new URL(body.url);
  if (url.protocol !== "https:" || !["whop.com", "www.whop.com"].includes(url.hostname) || url.username || url.password || !url.pathname.startsWith("/checkout/") || url.pathname === "/checkout/") throw new Error("Checkout could not be opened. Please try again.");
  return url.href;
}
export function navigateToCheckout(url: string) { window.location.assign(url); }
